export interface Attribution {
  utm_source: string;
  utm_medium: string;
  utm_campaign: string;
  referrer: string;
  landing: string;
}

const KEY = 'vcars-attribution-v1';

function sourceFromReferrer(ref: string): string {
  if (!ref) return 'directo';
  try {
    const host = new URL(ref).hostname.replace(/^www\./, '');
    if (host === window.location.hostname) return 'directo';
    if (/google\./.test(host)) return 'google';
    if (/facebook\.com|fb\.com/.test(host)) return 'facebook';
    if (/instagram\.com/.test(host)) return 'instagram';
    if (/tiktok\.com/.test(host)) return 'tiktok';
    return host;
  } catch {
    return 'otro';
  }
}

/** Guarda el origen de la primera visita de la sesión (UTM o sitio de referencia). */
export function captureAttribution(): void {
  try {
    const params = new URLSearchParams(window.location.search);
    const hasUtm = params.has('utm_source') || params.has('utm_campaign');
    if (sessionStorage.getItem(KEY) && !hasUtm) return;
    const data: Attribution = {
      utm_source: params.get('utm_source') || sourceFromReferrer(document.referrer),
      utm_medium: params.get('utm_medium') || '',
      utm_campaign: params.get('utm_campaign') || '',
      referrer: document.referrer || '',
      landing: window.location.pathname,
    };
    sessionStorage.setItem(KEY, JSON.stringify(data));
  } catch {
    // sessionStorage no disponible: se envía sin origen.
  }
}

export function getAttribution(): Attribution {
  try {
    const raw = sessionStorage.getItem(KEY);
    if (raw) return JSON.parse(raw) as Attribution;
  } catch {
    // ignorar
  }
  return { utm_source: 'directo', utm_medium: '', utm_campaign: '', referrer: '', landing: '' };
}
